import brakeContract from '~/assets/icons/brake_contract.svg';
import clock from '~/assets/icons/clock.svg';
import noPic from '~/assets/icons/no_pic.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import drsLogo from '../../assets/images/drs_logo.svg';
import {
	StyledActiveOrderInfoContainer,
	StyledInfoContainer,
	StyledNotActivePicContainer,
	StyledTag,
	StyledTagsContainer,
	StyledTimeContainer,
} from './AppTruckJobActiveContract.styled';

const AppTruckJobActiveContract = ({ state }: { state?: 'tags' | 'time' }) => {
	const activeContract = true;

	return (
		<StyledActiveOrderInfoContainer $isActive={activeContract} $state={state}>
			{activeContract ? (
				<img src={drsLogo} />
			) : (
				<StyledNotActivePicContainer>
					<img src={noPic} />
				</StyledNotActivePicContainer>
			)}
			<StyledInfoContainer>
				<Text style={{ fontSize: 12, color: '#ffffff', opacity: 0.5 }}>
					Активный контракт
				</Text>
				<Text
					style={{
						fontSize: 14,
						fontWeight: 500,
						color: '#ffffff',
						marginTop: 4,
					}}
				>
					{activeContract ? 'DRS GROUP' : 'У вас нет активного контракта'}
				</Text>
				{activeContract && state === 'tags' && (
					<StyledTagsContainer>
						<StyledTag>
							<Text>2 Уровень</Text>
						</StyledTag>
						<StyledTag>
							<Text>2 450 XP</Text>
						</StyledTag>
					</StyledTagsContainer>
				)}
				{activeContract && state === 'time' && (
					<StyledTimeContainer>
						<Text style={{ fontSize: 14, color: '#ffffff', opacity: 0.5 }}>
							Осталось:
						</Text>
						<ImgIcon icon={clock} width={14} height={14} color="#FFBB00" />
						<Text style={{ fontSize: 14, fontWeight: 700, color: '#FFBB00' }}>
							00:44:00
						</Text>
					</StyledTimeContainer>
				)}
			</StyledInfoContainer>
			{activeContract && (
				<Button
					color={ButtonColors.Cancel}
					height={ButtonHeight.Height60}
					style={{ padding: 0 }}
				>
					<img src={brakeContract} width={20} height={20} />
				</Button>
			)}
		</StyledActiveOrderInfoContainer>
	);
};

export { AppTruckJobActiveContract };
